import styled from "styled-components";

export const ContainerPage = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

export const ContainerContent = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  gap: 16px;
  overflow-y: auto;
`;
